import { render, staticRenderFns } from "./new-year-chance.vue?vue&type=template&id=2e15bd79&scoped=true&"
import script from "./new-year-chance.vue?vue&type=script&lang=js&"
export * from "./new-year-chance.vue?vue&type=script&lang=js&"
import style0 from "./new-year-chance.vue?vue&type=style&index=0&id=2e15bd79&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e15bd79",
  null
  
)

export default component.exports